import { Action } from '@/_core/fluxstore/types';
import { ConfirmState, ConfirmDismissReason } from '../types';

import { useConfirmModule } from '..';
const { registerReducer } = useConfirmModule();

export class CloseConfirm extends Action<ConfirmState> {
    public static ACTION_TYPE = 'AppConfirm::CloseConfirm';
    public constructor(public instanceId?: number, public reason: ConfirmDismissReason | 'selected' = 'dismissed', public ownerId?: string) {
        super(CloseConfirm.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer = (state: ConfirmState, action: CloseConfirm): void => {
    if (!state.isOpen || (action.instanceId !== undefined && state.instanceId !== action.instanceId) ||
        (action.ownerId !== undefined && state.ownerId !== action.ownerId)) return;
    const onDismiss = state.onDismiss;
    state.isOpen = false;
    state.onDismiss = undefined;
    if (action.reason !== 'selected' && onDismiss) onDismiss(action.reason);
};

//@ts-ignore
registerReducer(CloseConfirm.ACTION_TYPE, reducer);
